import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/_utils/auth.guard";

export const RealEstateRoutes: Routes = [
    { 
        path: 'panel-inversor', 
        loadChildren: () => import('./private/private-realestate.routes').then(r => r.PrivateRealEstateRoutes), 
        canActivate: [AuthGuard] 
    },
    { 
        path: '', 
        loadChildren: () => import('./public/public-realestate.routes').then(r => r.PublicRealEstateRoutes), 
    },
];
